import {asset} from 'imba';
import url from './bookmark.svg';
export default asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"},"flags":["feather","feather-bookmark"],"content":"<path d=\"M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z\"></path>"},
	toString: function(){ return this.url;}
})